import { useEffect } from 'react';

/**
 * Hook to hide the body overflow when the component is mounted
 * and restore the original overflow when the component is unmounted
 * @returns {void}
 */
export default function useBodyOverflowHidden() {
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);
}
